import { render, staticRenderFns } from "./CleanerArrival.vue?vue&type=template&id=704dd80e&scoped=true"
import script from "./CleanerArrival.vue?vue&type=script&lang=js"
export * from "./CleanerArrival.vue?vue&type=script&lang=js"
import style0 from "./CleanerArrival.vue?vue&type=style&index=0&id=704dd80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704dd80e",
  null
  
)

export default component.exports